module.exports = __webpack_public_path__ + "static/media/old_phone.55418eaa.svg";